(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.cms.common.provider.oauth.facebook'

  require('angularjs-facebook')

  require('angular')
    .module(MODULE_NAME, [
      'facebook'
    ])
    .config(facebookConfig)

  facebookConfig.$inject = ['FacebookProvider', 'SdkConfigProvider']
  function facebookConfig (FacebookProvider, SdkConfigProvider) {
    FacebookProvider.init(SdkConfigProvider.get('fb_app_id'))
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/cms/common/provider/oauth/facebook.js